import React, { ReactElement, useEffect, useState, useContext } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import gridStyle from '@pages/forms/Grid.module.scss';
import { getStringIndex, setFormDataValues, setCurrentFormikValues, navigateToError, bytesToMBSize } from '@utils';
import VicFinesContext from '@pages/forms/VicFinesFormContext';
import { getInitiate, checkExistingForm, getPartialForm, getValidFilesConfig, getGroundsInfo, getBasicInfo } from '@api';
import { FormType } from '@constants';
import { Accordion, FormLoading } from '@components';
import { useFormikContext } from 'formik';
import ClockIcon from '../../../../images/clock.svg';
import styles from './NominationStep0.module.scss';

interface iProps {
  formikRef: any;
}

function NominationStep0({ formikRef }: iProps): ReactElement {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const pathElementArray = location.pathname.split('/');
  const { tooltips } = useContext(VicFinesContext);
  const stepIndex = getStringIndex(pathElementArray, 'step');
  const stepIndexDiff = stepIndex - pathElementArray.length;
  const pathNameLessLastSegment = stepIndex ? location.pathname.split('/').slice(0, stepIndexDiff).join('/') : location.pathname;
  const validTitles = Object.keys(tooltips).filter((v) => v.includes('step0'));
  const formikcontext = useFormikContext();
  function getStringForSort(stringVal: string): string {
    return stringVal.substring(stringVal.indexOf('p') + 1, stringVal.indexOf('|'));
  }
  validTitles.sort((stringA, stringB) => Number(getStringForSort(stringA)) - Number(getStringForSort(stringB)));
  const { ob } = useParams<{ ob?: string }>();
  useEffect(() => {
    let pathNameLessLastSegmentOnLoad = '';
    let obNumFromPath = '';
    if (window.location.hash) {
      window.history.pushState({}, '', window.location.pathname + window.location.hash.replaceAll('#', ''));
      const currentUrl = window.location.pathname;
      const pathUrlArray = currentUrl.split('/');
      const stepCurrentIndex = getStringIndex(pathUrlArray, 'step');
      const stepIndexDiffOnLoad = stepCurrentIndex - pathUrlArray.length;
      pathNameLessLastSegmentOnLoad = stepCurrentIndex ? pathUrlArray.slice(0, stepIndexDiffOnLoad).join('/') : currentUrl;
      obNumFromPath = pathUrlArray.includes('step0') && pathUrlArray[stepCurrentIndex + 1] ? pathUrlArray[stepCurrentIndex + 1] : '';
    }
    const obNum = obNumFromPath || ob;
    if (obNum) {
      setLoading(true);
      checkExistingForm(obNum, FormType.NOMINATION)
        .then((valueOfExistingform) => {
          // if (!valueOfExistingform?.PartialFormID) {
          //   setLoading(false);
          //   navigate(`${pathNameLessLastSegment || pathNameLessLastSegmentOnLoad}/step0`);
          //   return;
          // }
          let currentStep = '';
          let partialFormID = 0;
          const partialFormOption = valueOfExistingform.CheckingExisting;
          const canSave = valueOfExistingform.CanSave;
          let savingoption = '';
          let debtorID = 0;
          if (partialFormOption === 'no' && valueOfExistingform.DebtorID && valueOfExistingform.PartialFormID) {
            return;
          }
          if (valueOfExistingform.CheckingExisting === 'yes') {
            formikcontext.setFieldValue('SaveYesNo', 'true');
            partialFormID = valueOfExistingform.PartialFormID!;
            formikcontext.setFieldValue('PartialFormID', partialFormID);
            savingoption = valueOfExistingform.CanSave ? 'yes' : 'no';
            if (valueOfExistingform.PartialFormID) {
              getPartialForm(valueOfExistingform.PartialFormID)
                .then((resBody) => {
                  if (typeof resBody === 'string') {
                    if (resBody === 'Unauthorised') {
                      navigateToError();
                    }
                  } else {
                    if (resBody.Obligations) {
                      if (resBody.Obligations[0].ObligationNO !== obNum) {
                        formikcontext.setFieldValue('alreadySavedForm', true);
                      }
                    }
                    const formData = JSON.parse(resBody.FormData);
                    const keys = Object.keys(resBody);
                    keys.forEach((key) => {
                      if (key === 'FormData') {
                        setFormDataValues(formData, formikRef?.current?.values.FormData, formikRef, 'FormData');
                        setCurrentFormikValues(formData, formikRef?.current?.values, formikRef);
                      } else if (resBody[key]) {
                        formikcontext.setFieldValue(`${key}`, resBody[key]);
                      }
                    });
                  }
                })
                .catch((e) => console.log(e));
            }
          } else {
            debtorID = valueOfExistingform.DebtorID!;
            savingoption = 'no';
            formikcontext.setFieldValue('OBLIGATION_NUMBER', obNum);
            formikcontext.setFieldValue('DebtorID', debtorID);
          }
          formikcontext.setFieldValue('SaveOptions', savingoption);
          getInitiate(obNum, FormType.NOMINATION).then(async (value) => {
            if (value.Number) {
              if (value?.Authorised && value?.Authorised.OffenceDate && value?.Authorised.InfringementNumber) {
                const [day, month, year] = value.Authorised.OffenceDate.split('/').map(Number);
                formikcontext.setFieldValue('OFFENCE_DATE', new Date(year, month - 1, day));
                formikcontext.setFieldValue('InfringementNoticeNumber', value?.Authorised.InfringementNumber);
              } else {
                currentStep = '/';
              }
              try {
                Promise.all([
                  getGroundsInfo(obNum, FormType.NOMINATION),
                  getValidFilesConfig(),
                  getBasicInfo(obNum, FormType.NOMINATION)
                ])
                  .then(([groundsInfo, validFilesConfig, basicInfo]) => {
                    if (groundsInfo && groundsInfo?.FineStage) {
                      formikcontext.setFieldValue('FineStage', groundsInfo?.FineStage);
                      formikcontext.setFieldValue('HasBeenNominatedBefore', groundsInfo?.HasBeenNominatedBefore);
                      formikcontext.setFieldValue('OffenceType', groundsInfo?.OffenceType);
                      formikcontext.setFieldValue('IsMarineOffence', groundsInfo?.IsMarineOffence);
                      formikcontext.setFieldValue('IsTsvOffence', groundsInfo?.IsTsvOffence);
                      formikcontext.setFieldValue('IsSeriousOffence', groundsInfo?.IsSeriousOffence);
                    }
                    if (validFilesConfig) {
                      const validFileInfo = validFilesConfig.find((item) => item.FormType === FormType.NOMINATION);
                      formikcontext.setFieldValue('FileUploadSizeConfig', bytesToMBSize(validFileInfo?.FileSize || 0));
                      formikcontext.setFieldValue('FileUploadDescriptionConfig', validFileInfo?.Description);
                      formikcontext.setFieldValue('FileUploadMaxAttachmentsConfig', validFileInfo?.MaxAttachments);
                    }
                    if (basicInfo) {
                      formikcontext.setFieldValue('Status', basicInfo.Status);
                      formikcontext.setFieldValue('DebtorType', basicInfo.DebtorType);
                      if (basicInfo.DebtorType === 'Individual') {
                        formikcontext.setFieldValue('isDebtorTypeIndividual', true);
                      }
                    } else {
                      currentStep = '/';
                      navigate(`${pathNameLessLastSegment || pathNameLessLastSegmentOnLoad}${currentStep}`);
                    }
                  });
              } catch (e) {
                console.log(e);
                navigateToError();
              }
               if (partialFormOption === 'no' && canSave === true) {
                  currentStep = '/step3';
                } else {
                currentStep = value.Step;
              }
            } else {
              currentStep = '/';
            }
            navigate(`${pathNameLessLastSegment || pathNameLessLastSegmentOnLoad}${currentStep}`);
          });
        })
        .catch(() => {
          console.log('Caught p2');
        });
    }
    return () => {
      setLoading(false);
    };
  }, []);
  return (
    <>
      {loading && <FormLoading />}
      {!loading && (
        <div className={gridStyle.form}>
          <div className="vfH2">Before you start</div>
          {validTitles.map((v) => {
            const getTitles = v.substring(v.indexOf('|'), v.length).replaceAll('|', ' ');
            return <Accordion title={getTitles} key={v} openByDefault={false} popupContent={tooltips[v]} />;
          })}
          <div className={styles.infoDiv}>
            <img src={ClockIcon} alt="alarm clock" />
            <span className={styles.info}>Please allow up to 15 minutes to complete this form.</span>
          </div>
        </div>
      )}
    </>
  );
}

export default NominationStep0;
